import { HistoryMessageSegment } from "types/historyMessageTypes";

/**
 * Builds formatted message for MESSAGE history type
 * Add implementation when product owner defines format
 */
export class MessageMessageBuilder {
  static build(message: any): HistoryMessageSegment[] {
    // TODO: Define format for MESSAGE type
    return [];
  }
}
